import { ProtoSpriteThree } from "protosprite-three";
import { useEffect, useMemo, useState } from "react";
import { DoubleSide, ShaderMaterial } from "three";

import { LoadableProtospriteResource } from "../../loader/LoadableProtospriteResource";

export function useProtospriteInstance<
  TL extends string = string,
  TT extends string = string
>(prsUrl: string, indexOrName?: string): ProtoSpriteThree<TL, TT> | null {
  const resource = useMemo(
    () => new LoadableProtospriteResource<TL, TT>(prsUrl),
    [prsUrl]
  );
  const [instance, setInstance] = useState<ProtoSpriteThree<TL, TT> | null>(
    null
  );

  useEffect(() => {
    let sprite: ProtoSpriteThree<TL, TT> | null = null;

    const doLoad = async () => {
      await resource.load();
      const loadedSheet = resource.getResource();
      sprite = loadedSheet.getSprite<TL, TT>(indexOrName);
      const mat = sprite.mesh.material as ShaderMaterial;
      mat.side = DoubleSide;
      sprite.center();
      setInstance(sprite);
    };

    doLoad();

    return () => {
      if (sprite) sprite.dispose();
    };
  }, [resource, indexOrName]);

  return instance;
}
